import { render, staticRenderFns } from "./RenewalNavbar.vue?vue&type=template&id=b37fb65c&scoped=true&"
import script from "./RenewalNavbar.vue?vue&type=script&lang=js&"
export * from "./RenewalNavbar.vue?vue&type=script&lang=js&"
import style0 from "./RenewalNavbar.vue?vue&type=style&index=0&id=b37fb65c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37fb65c",
  null
  
)

export default component.exports